import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from 'shared/types/redux';
import { fetchAcceptPublicOffer } from '../../../services/joinOtaIndividual/fetchAcceptPublicOffer';
import { TPublicOfferAcceptResponse } from '../../../repositories/dailyrent/v1/public-offer/accept';
import { goToErrorStep, goToNextStep } from '../../../slices/joinOtaIndividual';

export const acceptPublicOffer = createAsyncThunk<TPublicOfferAcceptResponse, undefined, IThunkApi>(
  'joinOtaIndividual/acceptPublicOffer',
  async (_, thunkApi) => {
    const { rejectWithValue, extra: context } = thunkApi;

    try {
      const response = await fetchAcceptPublicOffer(context);
      thunkApi.dispatch(goToNextStep(thunkApi.getState().landingType));

      return response;
    } catch (e) {
      thunkApi.dispatch(goToErrorStep());

      return rejectWithValue(e);
    }
  },
);
